import { inject, Injectable } from '@angular/core';
import { TagService } from '@eview/core/domain/tags/tag.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import {
  ETagsActions,
  ListTags,
  ListTagsFailure,
  ListTagsSuccess
} from '../actions/tags.actions';
import { selectTagsLoaded } from '../selectors/catalog.selectors';
import { AppState } from '../states/app.state';

@Injectable()
export class TagsEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store<AppState>);
  private readonly tagService = inject(TagService);

  list$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ListTags>(ETagsActions.ListTags),
      withLatestFrom(this.store.select(selectTagsLoaded)),
      filter(([action, loaded]) => action.force || !loaded),
      switchMap(() =>
        this.tagService.list().pipe(
          map(payload => new ListTagsSuccess(payload)),
          catchError(() => of(new ListTagsFailure()))
        )
      )
    )
  );
}
